import React, { useEffect, useState } from 'react';
import getRewardfulCoupon from '../lib/getRewardfulCoupon';
import useCheckoutHelpers from './useCheckoutHelpers';
import useCheckoutState from './useCheckoutState';
import getRewardfulReferral from '../lib/getRewardfulReferral';

const RewardfulContext = React.createContext();

function RewardfulProvider({ children }) {
  // only handle rewardful coupon once
  const [handledRewardfulCoupon, setHandledRewardfulCoupon] = useState(false);

  const { setShowCouponCodeField } = useCheckoutState();

  const { validateCoupon, getCouponByStripeCouponId } = useCheckoutHelpers();

  const rewardfulCoupon = getRewardfulCoupon();

  useEffect(() => {
    async function setCoupon(couponCode) {
      try {
        await validateCoupon(couponCode);
        setShowCouponCodeField(true);
      } catch (error) {
        // no-op
      }
    }

    async function getAndApplyCoupon(rewardfulCoupon) {
      try {
        const coupon = await getCouponByStripeCouponId(rewardfulCoupon.id);
        setCoupon(coupon.code);
      } catch (error) {
        // no-op
      }
    }

    if (rewardfulCoupon && handledRewardfulCoupon === false) {
      getAndApplyCoupon(rewardfulCoupon);
      setHandledRewardfulCoupon(true);
    }
  }, [
    rewardfulCoupon,
    handledRewardfulCoupon,
    getCouponByStripeCouponId,
    setShowCouponCodeField,
    validateCoupon,
  ]);

  const rewardfulReferral = getRewardfulReferral();

  return (
    <RewardfulContext.Provider
      value={{
        rewardfulCoupon,
        handledRewardfulCoupon,
        rewardfulReferral,
      }}
    >
      {children}
    </RewardfulContext.Provider>
  );
}

export default function useRewardful() {
  const context = React.useContext(RewardfulContext);

  if (context === undefined) {
    throw new Error('useRewardful must be used within a RewardfulProvider');
  }

  return context;
}

export { RewardfulProvider };
